import { Button } from "antd";
import styled from "styled-components";

export const LogoutButtonStyled = styled(Button)`
    height: 32px;
`;
